<app-pan-card [isPageContainer]="true" [header]="'Sideload a Review'" pageContainerSize="xl">
  <div class="my-6 w-3/4">
    <form class="location-form">
      <app-pan-form-control>
        <app-pan-floating-label>Sideload Location</app-pan-floating-label>
        <ng-select
          class="form-control"
          [items]="locationOptions | async"
          [formControl]="locationControl"
          [searchFn]="search"
          [virtualScroll]="true"
          placeholder="Select location..."
          (change)="changeLocation($event)"
        >
          <ng-template ng-label-tmp let-item="item">
            <span class="relative" [ngClass]="item.is_flagged ? 'text-red-600' : ''">
              @if (item.is_flagged) {
                <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none">
                  <mat-icon>flag</mat-icon>
                </div>
              }
              <span [ngClass]="item.is_flagged ? 'ps-10 p-2.5' : ''">
                {{ item.location_name }}
                <span class="text-xs">({{ item.branch_name }})</span>
              </span>
            </span>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <span class="relative" [ngClass]="item.is_flagged ? 'text-red-600' : ''">
              @if (item.is_flagged) {
                <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none">
                  <mat-icon>flag</mat-icon>
                </div>
              }
              <span [ngClass]="item.is_flagged ? 'ps-10 p-2.5' : ''">
                {{ item.location_name }}
                <span class="text-xs">({{ item.branch_name }})</span>
              </span>
            </span>
          </ng-template>
        </ng-select>
      </app-pan-form-control>
    </form>

    <div [hidden]="!locationControl.value?.hasOwnProperty('location_name')">
      <mat-radio-group [(ngModel)]="sideloadedReviewKind">
        @for (reviewKind of reviewKinds; track reviewKind) {
          <div class="flex items-center ps-4 my-4 border border-gray-200 rounded">
            <mat-radio-button
              color="primary"
              class="example-radio-button"
              [value]="reviewKind.id"
              [disabled]="reviewKind.id === ReviewSubjectType.Walkout && !walkoutAvailable()"
            >
              {{ reviewKind.label }}
              @if (reviewKind.id === ReviewSubjectType.Walkout && !walkoutAvailable()) {
                <span class="text-sm text-gray-500 ms-2">(No walkouts available)</span>
              }
            </mat-radio-button>
          </div>
        }
      </mat-radio-group>

      @if (sideloadedReviewKind === ReviewSubjectType.Sideloaded) {
        <div class="my-6">
          <app-pan-form-control>
            <app-pan-floating-label>Review Instructions (required)</app-pan-floating-label>
          </app-pan-form-control>

          <textarea
            panTextarea
            id="review-message"
            [(ngModel)]="reviewMessage"
            rows="4"
            class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Write any notes for the investigator..."
          ></textarea>
        </div>
      }
      <div class="w-full">
        <div class="flex items-center">
          <button
            [disabled]="isLoading()"
            (click)="createReview()"
            class="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-white bg-blue-700 border hover:bg-blue-800 rounded-s-lg border-blue-700 hover:border-blue-700focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            @if (isLoading()) {
              <app-pan-spinner></app-pan-spinner>
            }
            Create a review for {{ locationControl.value?.location_name }}
          </button>
          <div class="relative w-full">
            <input
              id="review-generator"
              type="text"
              aria-describedby="helper-text-explanation"
              placeholder="..."
              class="bg-gray-50 border border-gray-300 text-gray-500 text-sm border-s-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              [(ngModel)]="reviewUrl"
              readonly
              disabled
            />
          </div>

          <app-pan-button icon="content_copy" color="primary" class="ml-2" type="button" (click)="copyUrl()" [disabled]="!reviewUrl()">
          </app-pan-button>
        </div>

        @if (errorMessage().length > 0) {
          <div class="py-6 text-sm font-medium text-danger">
            {{ errorMessage() }}
          </div>
        }
      </div>
    </div>
  </div>
</app-pan-card>
